// Espelha o _slugify do backend: NFKD + descarta não-ASCII + kebab-case.
export const slugifyClient = (nome) => {
  const ascii = Array.from((nome || '').normalize('NFKD'))
    .filter((ch) => ch.charCodeAt(0) < 128)
    .join('');
  return (
    ascii
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 140) || 'skill'
  );
};

// Download client-side de um .md gerado a partir do conteudo (nada vai ao servidor).
export const downloadMd = (filename, content) => {
  const blob = new Blob([content], { type: 'text/markdown;charset=utf-8' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

// tags: skills do sistema usam array; prompts (Minhas Skills) usam CSV string.
export const tagsToArray = (tags) => {
  if (Array.isArray(tags)) return tags.filter(Boolean);
  return String(tags || '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
};

export const tagsToCsv = (arr) => (Array.isArray(arr) ? arr.filter(Boolean).join(', ') : '');

// Sugestões de plataforma para o selo de compatibilidade (admin/usuário
// também pode digitar uma nova).
export const PLATFORM_SUGGESTIONS = [
  'Veo Flow', 'Midjourney', 'Nano Banana', 'GPT', 'Sora', 'Kling', 'Runway', 'Leonardo',
];

const DAYS_MS = 24 * 60 * 60 * 1000;
const FRESH_DAYS = 14;

// Badge "Nova": criada nos últimos 14 dias.
export const isNewSkill = (skill) => {
  if (!skill?.created_at) return false;
  const created = Date.parse(skill.created_at);
  return Number.isFinite(created) && Date.now() - created < FRESH_DAYS * DAYS_MS;
};

// Badge "Atualizada": editada nos últimos 14 dias, bem depois de criada
// (mais de 24h), e sem já estar marcada como "Nova".
export const isUpdatedSkill = (skill) => {
  if (isNewSkill(skill) || !skill?.updated_at || !skill?.created_at) return false;
  const updated = Date.parse(skill.updated_at);
  const created = Date.parse(skill.created_at);
  if (!Number.isFinite(updated) || !Number.isFinite(created)) return false;
  return updated - created > DAYS_MS && Date.now() - updated < FRESH_DAYS * DAYS_MS;
};

// Normaliza um prompt (tabela prompts) para o shape de skill usado pelos
// componentes compartilhados (card/detalhe). anotacoes vira a descrição.
export const userSkillFromPrompt = (p) => ({
  id: p.id,
  canal_id: p.canal_id || null,
  nome: p.nome || '',
  descricao: p.anotacoes || '',
  categoria: p.categoria || '',
  tags: tagsToArray(p.tags),
  plataformas: Array.isArray(p.plataformas) ? p.plataformas : [],
  imagens: Array.isArray(p.imagens) ? p.imagens : [],
  conteudo: p.conteudo || '',
  instrucoes: p.instrucoes || '',
  video_url: p.video_url || '',
  favorito: !!p.favorito,
  isUser: true,
});

// Máscara de privacidade (modo privado do app): preserva quebras de linha.
export const maskContent = (text) =>
  String(text || '').replace(/[^\n]/g, '•');

// URL de vídeo em ARQUIVO direto (mp4/webm/mov).
export const isDirectVideoUrl = (url) =>
  /\.(mp4|webm|mov)(\?.*)?$/i.test(String(url || ''));

// Item da galeria de exemplos (campo `imagens`) que é VÍDEO upado: marcado
// com tipo:'video' pelo admin; fallback pela extensão p/ itens antigos.
export const isVideoItem = (item) =>
  item?.tipo === 'video' || isDirectVideoUrl(item?.url);
